export const DEFAULT_AUTH_KEY = "default-auth"
